import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { PRODGY_CHART_COLORS } from '@/shared/constants/colors';
import { useChartTheme } from './chartTheme';

interface ScatterChartProps {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  config: {
    xAxis?: string;
    yAxis?: string;
    groupBy?: string;
  };
}

export const ScatterChart = ({ data, config: _config }: ScatterChartProps) => {
  const chart = useChartTheme();

  const option: EChartsOption = {
    color: PRODGY_CHART_COLORS,
    backgroundColor: chart.background,
    textStyle: { color: chart.axisLabel },
    tooltip: {
      trigger: 'item',
      backgroundColor: chart.tooltipBg,
      borderColor: chart.tooltipBorder,
      textStyle: {
        color: chart.tooltipText,
      },
    },
    grid: {
      left: '3%',
      right: '7%',
      bottom: '7%',
      top: '10%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: chart.axisLine,
        },
      },
      axisLabel: {
        color: chart.axisLabel,
      },
      splitLine: {
        lineStyle: {
          color: chart.splitLine,
        },
      },
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: chart.axisLine,
        },
      },
      axisLabel: {
        color: chart.axisLabel,
      },
      splitLine: {
        lineStyle: {
          color: chart.splitLine,
        },
      },
    },
    series: data.series || [
      {
        symbolSize: 8,
        data: data.data || [],
        type: 'scatter',
        itemStyle: {
          color: PRODGY_CHART_COLORS[0],
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};
